import axios from 'axios';

export const resolveBackendUrl = () => {
    const configuredUrl = process.env.REACT_APP_BACKEND_URL;
    if (!configuredUrl || typeof window === 'undefined') return configuredUrl;

    try {
        const url = new URL(configuredUrl);
        const isLanDevelopment =
            process.env.NODE_ENV === 'development' &&
            !['localhost', '127.0.0.1'].includes(window.location.hostname);

        if (
            isLanDevelopment &&
            ['localhost', '127.0.0.1'].includes(url.hostname)
        ) {
            url.hostname = window.location.hostname;
        }

        return url.toString().replace(/\/$/, '');
    } catch {
        return configuredUrl;
    }
};

const api = axios.create({
    baseURL: resolveBackendUrl(),
    withCredentials: true,
    headers: {
        'X-Bjorn-Client': 'captions-web',
    },
});

// Request interceptor to add auth token
api.interceptors.request.use(
    async config => {
        const token = localStorage.getItem('captions_token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    error => {
        return Promise.reject(error);
    }
);

// Response interceptor to handle auth errors
api.interceptors.response.use(
    response => response,
    async error => {
        if (error.response?.status === 401) {
            // Token invalid - clear storage
            localStorage.removeItem('captions_token');
            localStorage.removeItem('captions_user_id');
        }
        return Promise.reject(error);
    }
);

export default api;
